<script setup lang="ts"></script>

<template>
  <div class="mx-2 mb-4 w-full xl:w-48">
    <slot></slot>
  </div>
</template>
